module.exports = {
  API_URL: 'https://api.konekto.ba/api',
  ENV: 'production',
  DEBUG: false,
}
